import {FlexBoxFetch, default as FlexBox} from "@kne/flex-box";

export * from '@kne/flex-box';

FlexBox.Fetch = FlexBoxFetch;
export default FlexBox;
